import { firebaseAuth } from "./firebase";

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: unknown;

  constructor(status: number, body: Record<string, unknown>) {
    const code = typeof body.error === "string" ? body.error : `HTTP_${status}`;
    const message = typeof body.message === "string" ? body.message : code;
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = body.issues ?? body;
  }
}

async function request<T>(path: string, init: RequestInit, token: string): Promise<T> {
  const base = (import.meta.env.VITE_API_BASE || "/api/v2").replace(/\/$/, "");
  const response = await fetch(`${base}${path.startsWith("/") ? path : `/${path}`}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {})
    }
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as Record<string, unknown>;
    throw new ApiError(response.status, body);
  }
  return response.status === 204 ? (undefined as T) : response.json() as Promise<T>;
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = firebaseAuth?.currentUser ? await firebaseAuth.currentUser.getIdToken() : "";
  return request<T>(path, init, token);
}

/** Public capability-token endpoints must not wait for Firebase Auth restore. */
export function publicApiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  return request<T>(path, init, "");
}
